import { render, staticRenderFns } from "./Detail2.vue?vue&type=template&id=1558e48a&scoped=true&"
import script from "./Detail2.vue?vue&type=script&lang=js&"
export * from "./Detail2.vue?vue&type=script&lang=js&"
import style0 from "./Detail2.vue?vue&type=style&index=0&id=1558e48a&prod&lang=scss&"
import style1 from "./Detail2.vue?vue&type=style&index=1&id=1558e48a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1558e48a",
  null
  
)

export default component.exports